module.exports = __webpack_public_path__ + "img/CPTsample3.8f076027.png";